import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../enums/user-role.enum';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Verificar autenticación
  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url }
    });
  }

  // Verificar roles esperados si están definidos
  const expectedRoles = route.data?.['expectedRoles'] as UserRole[] | undefined;
  if (expectedRoles && expectedRoles.length > 0) {
    const currentUser = authService.getCurrentUser();
    if (!currentUser) {
      return router.createUrlTree(['/unauthorized']);
    }

    const userRole = currentUser.role as UserRole;
    const hasRequiredRole = expectedRoles.includes(userRole);

    if (!hasRequiredRole) {
      return router.createUrlTree(['/unauthorized'], {
        queryParams: { attemptedUrl: state.url }
      });
    }
  }

  return true;
};

